import { SafeHtml } from '@angular/platform-browser';

// ~~ Api
const API_ROUTE_PREFIX = 'registered/foreignCurrencyPocket';
const API_ENDPOINTS = {
    OpenAccount: 'openAccount',
    UmbracoOpenAccount: 'umbraco/openAccount',
    GetUserCards: 'getUserCards',
    UmbracoOpenAccountSuccess: 'umbraco/openAccountSuccess',
    GetQuota: 'getQuota',
    UmbracoRefill: 'umbraco/refill',
    UmbracoSell: 'umbraco/sell',
    UmbracoGeneral: 'umbraco/general',
    SellBuy: 'sellBuy',
    UpdateStatus: 'updateStatus',
    GetAccountData: 'getAccountData',
    GetGlbLoadTypes: 'getGlbLoadTypes',
    GetTransactions: 'getTransactions',
    GetGiftCard: 'getGiftCard',
    openAccountAndBuy: 'openAccountAndBuy',
    nextCycleDebit: 'nextCycleDebit',
    transactionSummaryByDate: 'transactionSummaryByDate',
    transactionSummaryByDateNew: 'transactionSummaryByDateNew',
    UmbracoConfirm: 'umbraco/confirm',
    GetPersonalRecommendation: 'getPersonalRecommendation',
    UpdateTable: 'updateForeignCitizenshipTable'
};

export const API_CONFIG = {
    API_ROUTE_PREFIX: API_ROUTE_PREFIX,
    API_ENDPOINTS: API_ENDPOINTS
};
// ~~

// ~~ Open Pocket Quota Timer
export const SECOND = 1000;
export class QuotaTimerConfig {
    private _duration: number; // in seconds

    constructor(duration: number) {
        this._duration = duration;
    }

    getMinutes(): number {
        return Math.trunc(this._duration / 60);
    }

    getSeconds(): number {
        return this._duration % 60;
    }
}
// ~~

// ~~ app-fcp-title component
export type TitleType = 'buy-coin' | 'refill' | 'sell';
export const titleTypeTexts: {
    [key in TitleType]: string;
} = {
    'buy-coin': 'הסכום המקסימלי לקניה',
    refill: 'סכום המקסימלי לקניה:',
    sell: 'יתרת הארנק למכירה:'
};
// ~~

// ~~ app-success-page component
export type SourceTypes = 'buy-coin' | 'refill' | 'sell';
export interface SourceContent {
    titleImage: string;
    title: string;
    subTitle: string;
    sumTitle: string;
    sumFromBankTitle: string;
    marketing: string[];
    continueBtn: string;
    continueBtnURL: string;
    backBtn: string;
    backBtnURL: string;
    formData: {
        card: string;
        currency?: {
            amount?: string;
            symbol?: string;
            type?: string;
        };
        quota?: {
            quota?: number;
        };
    };
    currencyExtraData?: {
        currencyCode?: string;
        englishName?: string;
        hebrewName?: string;
        symbol?: string;
        sccessPageBtn?: string;
        successPageImage?: string;
        successPageTitle?: string;
    };
    asterix?: SafeHtml;
    sumNumber?: number;
}
// ~~
